"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CONTENT_DIRECTION = exports.BORDER_POSITION = exports.ACTION_POSITION = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));

var _styles = require("@material-ui/core/styles");

var _Card2 = _interopRequireDefault(require("./Card.css"));

var _ActionMenu = _interopRequireDefault(require("./ActionMenu"));

var _Typography = _interopRequireDefault(require("./../../elements/Typography"));

var ACTION_POSITION = {
  middle: 'middle',
  bottom: 'bottom'
};
exports.ACTION_POSITION = ACTION_POSITION;
var BORDER_POSITION = {
  top: 'top',
  left: 'left'
};
exports.BORDER_POSITION = BORDER_POSITION;
var CONTENT_DIRECTION = {
  row: 'row',
  column: 'column'
};
exports.CONTENT_DIRECTION = CONTENT_DIRECTION;

var Card =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Card, _React$PureComponent);

  function Card() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Card)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      anchorEl: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleActionClick", function (event) {
      var _this$props = _this.props,
          menuOptions = _this$props.menuOptions,
          onClose = _this$props.onClose;

      if (menuOptions) {
        _this.setState({
          anchorEl: event.currentTarget
        });
      } else if (onClose) {
        onClose();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMenuClose", function () {
      _this.setState({
        anchorEl: null
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Card, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          borderPosition = _this$props2.borderPosition,
          borderColor = _this$props2.borderColor,
          classes = _this$props2.classes,
          contentDirection = _this$props2.contentDirection,
          onClick = _this$props2.onClick,
          rootStyle = _this$props2.rootStyle,
          width = _this$props2.width;
      return _react.default.createElement(_Card.default, {
        className: (0, _clsx.default)(classes.root, borderColor && borderPosition === BORDER_POSITION.left && classes.borderLeft, borderColor && borderPosition === BORDER_POSITION.top && classes.borderTop, contentDirection === CONTENT_DIRECTION.row && classes.rootRow, onClick && classes.clickable),
        onClick: onClick,
        style: (0, _objectSpread2.default)({}, rootStyle, {
          borderColor: borderColor,
          width: width || ''
        })
      }, this.header, this.actionMiddle, this.content, this.actionBottom, contentDirection === CONTENT_DIRECTION.row && this.secondaryActions);
    }
  }, {
    key: "header",
    get: function get() {
      var _this$props3 = this.props,
          action = _this$props3.action,
          actionPosition = _this$props3.actionPosition,
          contentDirection = _this$props3.contentDirection,
          classes = _this$props3.classes,
          header = _this$props3.header,
          headerBackgroundColor = _this$props3.headerBackgroundColor,
          headerStyle = _this$props3.headerStyle;

      if (!header) {
        return null;
      }

      return _react.default.createElement("div", {
        className: (0, _clsx.default)(classes.header, contentDirection === CONTENT_DIRECTION.row && classes.headerRow, contentDirection === CONTENT_DIRECTION.column && action && actionPosition === ACTION_POSITION.middle && classes.headerMiddleAction),
        style: (0, _objectSpread2.default)({
          backgroundColor: headerBackgroundColor
        }, headerStyle)
      }, (0, _typeof2.default)(header) === 'object' ? header : _react.default.createElement(_Typography.default, {
        className: classes.title,
        variant: "h5",
        component: "h2"
      }, contentDirection === CONTENT_DIRECTION.column && this.secondaryActions, header));
    }
  }, {
    key: "secondaryActions",
    get: function get() {
      var _this$props4 = this.props,
          contentDirection = _this$props4.contentDirection,
          classes = _this$props4.classes,
          menuOptions = _this$props4.menuOptions,
          headerStyle = _this$props4.headerStyle,
          onClose = _this$props4.onClose;
      var anchorEl = this.state.anchorEl;

      if (!menuOptions && !onClose) {
        return null;
      }

      return _react.default.createElement("div", {
        className: (0, _clsx.default)(classes.secondaryActions, contentDirection === CONTENT_DIRECTION.row && classes.secondaryActionsRow),
        onClick: function onClick(event) {
          return event.stopPropagation();
        }
      }, _react.default.createElement(_IconButton.default, {
        "aria-label": "More",
        "aria-controls": "header-menu",
        "aria-haspopup": "true",
        onClick: this.handleActionClick,
        style: {
          color: headerStyle.color || ''
        }
      }, menuOptions ? _react.default.createElement(_MoreVert.default, null) : _react.default.createElement(_Clear.default, null)), menuOptions && _react.default.createElement(_ActionMenu.default, {
        anchor: anchorEl,
        onClose: this.handleMenuClose,
        options: menuOptions
      }));
    }
  }, {
    key: "content",
    get: function get() {
      var _this$props5 = this.props,
          contentDirection = _this$props5.contentDirection,
          contentStyle = _this$props5.contentStyle,
          children = _this$props5.children,
          classes = _this$props5.classes,
          header = _this$props5.header;

      if (!children) {
        return null;
      }

      return _react.default.createElement(_Typography.default, {
        className: (0, _clsx.default)(classes.content, contentDirection === CONTENT_DIRECTION.row && classes.contentRow),
        style: contentStyle,
        variant: "body2",
        component: "div"
      }, !header && contentDirection === CONTENT_DIRECTION.column && this.secondaryActions, children);
    }
  }, {
    key: "actionMiddle",
    get: function get() {
      var _this$props6 = this.props,
          action = _this$props6.action,
          actionPosition = _this$props6.actionPosition,
          actionStyle = _this$props6.actionStyle,
          classes = _this$props6.classes,
          contentDirection = _this$props6.contentDirection,
          header = _this$props6.header,
          headerBackgroundColor = _this$props6.headerBackgroundColor;

      if (!header || contentDirection === CONTENT_DIRECTION.row || !action || actionPosition === ACTION_POSITION.bottom) {
        return null;
      }

      return _react.default.createElement("div", {
        className: (0, _clsx.default)(classes.action, classes.actionMiddle),
        style: (0, _objectSpread2.default)({}, actionStyle, {
          background: "linear-gradient(180deg, ".concat(headerBackgroundColor, " 50%, transparent 0%)")
        })
      }, _react.default.createElement("div", {
        onClick: function onClick(event) {
          return event.stopPropagation();
        }
      }, action));
    }
  }, {
    key: "actionBottom",
    get: function get() {
      var _this$props7 = this.props,
          action = _this$props7.action,
          actionPosition = _this$props7.actionPosition,
          actionStyle = _this$props7.actionStyle,
          contentDirection = _this$props7.contentDirection,
          classes = _this$props7.classes;

      if (!action || actionPosition === ACTION_POSITION.middle && contentDirection === CONTENT_DIRECTION.column) {
        return null;
      }

      return _react.default.createElement("div", {
        className: (0, _clsx.default)(classes.action, contentDirection === CONTENT_DIRECTION.row && classes.actionRow),
        style: actionStyle
      }, _react.default.createElement("div", {
        onClick: function onClick(event) {
          return event.stopPropagation();
        }
      }, action));
    }
  }]);
  return Card;
}(_react.default.PureComponent);

Card.defaultProps = {
  action: null,
  actionPosition: ACTION_POSITION.bottom,
  actionStyle: {},
  borderColor: null,
  borderPosition: null,
  contentDirection: CONTENT_DIRECTION.column,
  contentStyle: {},
  header: null,
  headerBackgroundColor: 'transparent',
  headerStyle: {},
  menuOptions: null,
  onClick: null,
  onClose: null,
  rootStyle: {},
  width: null
};
Card.propTypes = {
  /**
   * Actions container. Have to be a React component
   */
  action: _propTypes.default.node,

  /**
   * Position of action block
   */
  actionPosition: _propTypes.default.oneOf(Object.keys(ACTION_POSITION)),

  /**
   * Styles for action container
   */
  actionStyle: _propTypes.default.object,

  /**
   * Border color
   */
  borderColor: _propTypes.default.string,

  /**
   * Position of border
   */
  borderPosition: _propTypes.default.oneOf(Object.keys(BORDER_POSITION)),

  /**
   * MUI classes from styles
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Flex direction of root container
   */
  contentDirection: _propTypes.default.oneOf(Object.keys(CONTENT_DIRECTION)),

  /**
   * Styles for content
   */
  contentStyle: _propTypes.default.object,

  /**
   * Header of the card. Can be a string or React component
   */
  header: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /**
   * Color of header background
   */
  headerBackgroundColor: _propTypes.default.string,

  /**
   * Styles for header
   */
  headerStyle: _propTypes.default.object,

  /**
   * Items passed into the component to be rendered as menu.
   */
  menuOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Label of the menu item component
     */
    label: _propTypes.default.node.isRequired,

    /**
     * Icon of the menu item component. Can be empty
     */
    icon: _propTypes.default.node,

    /**
     * Callback on selecting a certain menu item
     */
    onClick: _propTypes.default.func.isRequired
  })),

  /**
   * Callback on card clicking
   */
  onClick: _propTypes.default.func,

  /**
   * Callback on clicking close icon
   */
  onClose: _propTypes.default.func,

  /**
   * Styles for root container
   */
  rootStyle: _propTypes.default.object,

  /**
   * Width of Card in px
   */
  width: _propTypes.default.number
};

var _default = (0, _styles.withStyles)(_Card2.default)(Card);

exports.default = _default;